import { render, staticRenderFns } from "./AnnouncementDelete.vue?vue&type=template&id=4a2605e5&scoped=true"
import script from "./AnnouncementDelete.vue?vue&type=script&lang=js"
export * from "./AnnouncementDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2605e5",
  null
  
)

export default component.exports